<template>
  <!-- 查看原因弹出框 -->
  <e-dialog
    dialog-title="查看原因"
    :center-dialog-visible="reasonVisible"
    :popup-width="'560px'"
    close-btn
    :modal-append-to-body="false"
    @resetPopupData="reasonCancel"
  >
    <div>{{ refuseReasons }}</div>
  </e-dialog>
</template>

<script>
import EDialog from '@/modules/projectA/components/common/e-dialog';

export default {
  components: { EDialog },
  props: {
    reasonVisible: Boolean,
    refuseReasons: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  methods: {
    reasonCancel() {
      this.$emit('update:reasonVisible', false);
    },
  },
};
</script>
<style lang="scss" scoped></style>
